import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "../styles/Navbar.css";
import anavu_logo from "../images/iiit_logo_black.png";
import userIcon from "../images/user_icon.png";
// import logoutIcon from "../images/logoutIcon.png";
import {
  getToken,
  getProfile,
  setToken,
  setName,
  setUserID,
  getName,
} from "../Storage/Storage"; // Import getName for fetching user name
import { userProfile } from "../Services/AllServices";

const Navbar = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [userRole, setUserRole] = useState(null);
  const [downloadCount, setDownloadCount] = useState(null);
  const [showLogout, setShowLogout] = useState(false); // Track logout dropdown visibility
  const [name, setNameState] = useState(""); // Track user name
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const checkAuth = async () => {
      const token = await getToken();
      if (token) {
        const profile = await getProfile();
        setIsAuthenticated(true);
        setUserRole(profile);

        if (profile === "Teacher") {
          await userProfile((response) => {
            if (response && response.status === "success") {
              setDownloadCount(response.data.downloadCount);
            }
          });
        }

        const userName = await getName(); // Fetch the user's name
        setNameState(userName); // Set the user's name
      } else {
        setIsAuthenticated(false);
      }
    };

    checkAuth();
  }, []);

  const handleLogout = async () => {
    try {
      await setToken("");
      await setName("");
      await setUserID("");
      setIsAuthenticated(false);
      navigate("/signin");
    } catch (error) {
      console.error("Error logging out", error);
    }
  };

  const menuItems = [
    { label: "ANAVU", key: "/" },
    { label: "DOCUMENTATION" },
    { label: "TUTORIALS" },
    { label: "LICENSE", key: "/license" },
    { label: "ABOUT" },
  ];

  if (isAuthenticated) {
    const roleToDashboard = {
      Student: "/learner",
      Moderator: "/moderator/video-management",
      Teacher: downloadCount === false ? "/teacher/download" : "/teacher",
    };

    const dashboardRoute = roleToDashboard[userRole] || "/";
    menuItems.push({ label: "DASHBOARD", key: dashboardRoute });
  } else {
    menuItems.push({ label: "LOGIN/ACCOUNT", key: "/signin" });
  }

  const handleMenuClick = (key) => {
    if (key) {
      navigate(key);
    }
  };

  return (
    <nav className="landingPage_navbar">
      <div className="navbar-left">
        <img src={anavu_logo} alt="AnaVu Logo" className="navbar-logo" />
        <span className="navbar-title">AnaVu</span>
      </div>
      <div className="landing-navbar-right">
        {menuItems.map((item) => (
          <span
            key={item.label}
            className={`landing-navbar-link ${
              location.pathname === item.key ? "active" : ""
            } ${!item.key ? "disabled" : ""}`}
            onClick={() => handleMenuClick(item.key)}
          >
            {item.label}
          </span>
        ))}
        {isAuthenticated && (
          <div className="landing-header-user-profile">
            <div className="landing-header-user-name">
              {name ? name.toUpperCase() : "LOADING..."}
            </div>
            <img
              src={userIcon}
              alt="User Icon"
              className="landing-header-user-icon"
              onClick={() => setShowLogout(!showLogout)}
              style={{ cursor: "pointer" }}
            />
            {showLogout && (
              <button className="landing-logout-button" onClick={handleLogout}>
                <div className="landing-logout-text">Logout</div>
              </button>
            )}
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;
